<template>
  <tr
    :class="{ 'hidden-item': isHiddenItem, 'd-none' : !isDisplay, 'sales-quantity-error' : isSalesQuantityError }"
    :data-item-id="item.itemId"
  >
    <td class="text-left">{{item.middleName}}</td>
    <td class="col1" :class="{ 'hasRequest': col1.type == 'prepare' && item.hasRequest }">{{col1.quantities[item.itemId]}}</td>
    <td>
      <QuantityInput
        :item=item
        :type=col2.type
        :quantity=col2.quantities[item.itemId]
        :isRequired=col2.isRequired
        :isHiddenItem=isHiddenItem
        @changeQuantity=changeQuantity
      />
    </td>
    <td>
      <QuantityInput
        :item=item
        :type=col3.type
        :quantity=col3.quantities[item.itemId]
        :isRequired=col3.isRequired
        :isHiddenItem=isHiddenItem
        @changeQuantity=changeQuantity
        v-if="!isHideInput"
      />
    </td>
  </tr>
</template>


<script>
  import QuantityInput from '@/components/parts/QuantityInput';

  export default {
    name: 'ItemTableRow',
    props: {
      item: {},
      isHideInput: Boolean,
      isDisplay: Boolean,
      isHiddenItem: Boolean,
      col1: {},
      col2: {},
      col3: {},
    },
    data() {
      return {
        isSalesQuantityError: false,
      };
    },
    components: {
      QuantityInput,
    },
    methods: {
      changeQuantity(type, quantity) {
        if (type === 'stock') {
          this.isSalesQuantityError = (this.item.lastDeliveryQuantity < quantity);
        }
        this.$emit('setQuantity', type, this.item.itemId, quantity);
      },
    },
  };
</script>

<style lang="scss" scoped>
  tr {
    &.hidden-item {
      background: #cccccc;
    }

    &.sales-quantity-error {
      background: #FCCBCB;
    }

    > td {
      vertical-align: middle;
      border-color: #777777;
      font-size: 0.8rem;

      &:nth-of-type(3),
      &:nth-of-type(4) {
        padding: 0.75rem 0.3rem;
      }

      &.col1 {
        font-size: 1rem;
        &.hasRequest {
          color: #ff0000;
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/ItemTableRow.vue?31ae77dc